import Vue from 'vue'
import Router from 'vue-router'

// vuex
import * as commons from './plugins/vuex'

// import { mapMutations, mapGetters, mapState } from 'vuex'

// menu
import mainMenu from './routes/mainMenu'
import dashboardMenu from './routes/dashboardMenu'
import userMenu from './routes/userMenu'
import settingsMenu from './routes/settingsMenu'

Vue.use(Router)

let routesArray = []
let userRoutes = []

function addToRoute (menu) {
  menu.forEach(el => {
    if (el.userType === 'logged' || el.userType === 'admin') {
      el.beforeEnter = (to, from, next) => {
        commons.isLogged() ? next() : next('/login')
      }
    } else if (el.userType === 'guest') {
      el.beforeEnter = (to, from, next) => {
        !commons.isLogged() ? next() : next('/dashboard')
      }
    }

    routesArray.push(el)
  })
}

addToRoute(mainMenu)
addToRoute(dashboardMenu)
addToRoute(userMenu)
addToRoute(settingsMenu)

if (!commons.isLogged()) {
  userRoutes = routesArray.filter(route => route.userType === 'guest' || route.userType === 'all')
} else {
  userRoutes = routesArray.filter(route => route.userType === 'logged' || route.userType === 'all')
  if (commons.isAdmin()) userRoutes = userRoutes.concat(routesArray.filter(route => route.userType === 'admin'))
}

export default new Router({
  routes: userRoutes
})
